import { forwardRef } from 'react';
import { Icon } from '@/components/foundations';
import { Button, CopyField } from '@/components/forms';
import { Badge, ConnectionCard } from '@/components/data';

export type WebhookCardProps = {
  endpoint: string;
  /** Eventos assinados (`chip`). */
  events: readonly string[];
  active?: boolean;
  /** Mostra "Teste enviado ✓" no botão. */
  tested?: boolean;
  onTest?: () => void;
  className?: string;
};

/** Webhooks: endpoint copiável, eventos assinados e envio de teste. */
export const WebhookCard = forwardRef<HTMLElement, WebhookCardProps>(function WebhookCard({ endpoint, events, active = true, tested = false, onTest, className }, ref) {
  return (
    <ConnectionCard
      ref={ref}
      id="hooks"
      className={className}
      icon="webhook"
      iconTone="blue"
      title="Webhooks"
      status={active ? <Badge icon="checkc">Ativo</Badge> : <Badge tone="neutral" style={{ marginLeft: 'auto' }}>Inativo</Badge>}
      action={<Button className="big" id="test" onClick={onTest} style={{ padding: '0 30px', fontWeight: '500' }}>{tested ? 'Teste enviado ✓' : (<><Icon name="send" />Enviar teste</>)}</Button>}
    >
      <label className="label" htmlFor="wh" style={{ fontWeight: '500', fontSize: '16px', marginTop: '22px' }}>Endpoint</label>
      <CopyField id="wh" value={endpoint} copyLabel="Copiar endpoint" />
      <span className="label" style={{ fontWeight: '500', fontSize: '16px', margin: '24px 0 12px' }}>Eventos assinados</span>
      <div className="events">{events.map((e) => <span key={e} className="chip">{e}</span>)}</div>
    </ConnectionCard>
  );
});
